import React, {useState} from 'react';
import plusIcon from '../../assets/images/add-icon-min.svg';
import iconDelete from '../../assets/images/delete.svg';
import { toast } from 'react-toastify';
import AWS from 'aws-sdk'
import { uploadFile } from 'react-s3';

export default function VehicleImage(props) {
    const [key, setKey] = useState('');

    const handleImageChange = (e) => {
        props.setLoader(true);
        if(e.target.files[0]){
            let imageArray = e.target.files[0].name.split('.');
			if(imageArray.length > 2  && imageArray.length < 2 )
			{
				props.setErrorMessage("Double extension files are not allowed.");
                props.setLoader(false);
			}
            else if(imageArray[1] !== "jpeg" && imageArray[1] !== "jpg" && imageArray[1] !== "png" )
            {
                props.setLoader(false);
				props.setErrorMessage("Only jpeg, jpg or png images are allowed.");
			}
            else if(e.target.files[0].length > 5242880)
            {
                props.setLoader(false);
				props.setErrorMessage("Max size should be less than 5MB.");
            }
            else{
                props.setLoader(true);
                let fl = e.target.files[0];
                let el = e.target.files[0].name.length;
                let nm = e.target.files[0].name;


                let config = {
                    'bucketName' : process.env.React_App_S3_bucketName,
                    'dirName' : props.dirName,
                    'region' : process.env.React_App_S3_Region,
                    'accessKeyId' : process.env.React_App_S3_AccessKeyId,
                    'secretAccessKey' : process.env.React_App_S3_SecretAccessKey,
                    's3Url': process.env.React_App_S3_Url,
                };
                
                uploadFile(fl, config).then(d => {
                    console.log(d);
                    document.getElementById(props.imageId).src = d.location;
                    setKey(d.key);
                    props.setLoader(false);
                    let updatedDetails = { ...props.data };
                    updatedDetails[props.id] = d.location;
                    props.setData(updatedDetails);
                    props.setErrorMessage('');
                    e.target.value = '';
                }).catch(err => {
                    props.setErrorMessage(err.message);
                    props.setLoader(false);
                    e.target.value = '';
                })
            }
        }else{
            props.setErrorMessage('Please select an image.');
            props.setLoader(false);
            e.target.value = '';
        }
    }

    const deleteS3Object = async (key) => {
        return new Promise((resolve, reject) => {
            try {
                let s3bucket = new AWS.S3({
                    dirName : props.dirName,
                    accessKeyId: process.env.React_App_S3_AccessKeyId,
                    secretAccessKey: process.env.React_App_S3_SecretAccessKey,
                    Bucket: process.env.React_App_S3_bucketName,
                });
                var params = { Bucket: process.env.React_App_S3_bucketName, Key: key };
                s3bucket.deleteObject(params, function(err, data) {
                    if (err) reject(err); // an error occurred
                    else resolve(data); // successful response
                });
            } catch (e) {
                reject(e);
            }
        });
    };

    const handleDeleteImage = (e) => {
        props.setLoader(true);
        try {
            deleteS3Object(key)
            .then(response => {
                console.log(response)
                let updatedDetails = { ...props.data };
                updatedDetails[props.id] = '';
                props.setData(updatedDetails);
                document.getElementById(props.imageId).src = ''
                props.setLoader(false);
                //toast.error('Image removed succesfully');
            })
            .catch(error => {
                props.setLoader(false);
                toast.error('Something went wrong. Please try again later.');
                toast.error(error.error)
            })
        }catch (error) {
            props.setLoader(false);
            toast.error('Something went wrong. Please try again later.');
            console.log(error);
        }
    }

    return (
        <>
            <div key={props.id} className=" comman-btn form-group">
                <div style={{display : props.mainData === '' ? 'none' : 'block' }} className='previewImage'>
                    <p>{props.buttonName}</p>
                    <span onClick={(e) => handleDeleteImage(e)}>
                        <img className='deleIcon' src={iconDelete} />
                    </span>
                    <img id={props.imageId}></img>
                </div>
                <button style={{display : props.mainData === '' ? 'block' : 'none', borderColor : props.errorMessage ? 'red' : '#fff' }} onClick={() => {
                        document.getElementById(props.inputId).click();
                    }}>
                    <p>{props.buttonName}</p>
                    <input multiple={props.multiple && true} className='hidden' id={props.inputId} onChange={(e) => handleImageChange(e)} type='file' />
                    <span>
                        <img src={plusIcon} />
                    </span>
                </button>
                {props.errorMessage && <span className='form-error'>{props.errorMessage}</span>}
            </div>
        </>
    )
}
